export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-fr-BE.e519eb47.xlsx";